import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/auth";
import userReducer from "./reducers/user";
import loaderReducer from "./reducers/loader";
import formDataReducer from "./reducers/formData";
import activityReducer from "./reducers/activity";
import notificationsReducer from "./reducers/notifications";

const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    loader: loaderReducer,
    bookingData: formDataReducer,
    activity: activityReducer,
    notifications: notificationsReducer,
  },
});

export default store;
